var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 21 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#004C8D",
  fillRule: "evenodd",
  d: "M10.501 3.543c.346 0 .625.28.625.625v5.991l1.433-1.433a.625.625 0 1 1 .884.884l-2.5 2.5a.625.625 0 0 1-.884 0l-2.5-2.5a.625.625 0 1 1 .884-.884l1.433 1.433V4.168c0-.345.28-.625.625-.625m-6.458 7.292c0-.346.28-.625.625-.625h1.667a.625.625 0 0 1 0 1.25H5.293v2.916H15.71V11.46h-1.042a.625.625 0 1 1 0-1.25h1.667c.345 0 .625.28.625.625V15c0 .346-.28.625-.625.625H4.668a.625.625 0 0 1-.625-.625z",
  clipRule: "evenodd"
})));
export default SvgDownload;